<template>
  <div>
    <v-container>
      <div class="text-xs-right">
        <div>
          <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>search</v-btn>
        </div>
        <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
        <v-btn :loading="exportloading" color="grey" outline @click="exportxlsx">
          <em class="fas fa-file-export" />
          &nbsp; Export Member&nbsp;
        </v-btn>
        <!-- <v-btn @click="addBranch" depressed color="primary">ADD</v-btn> -->
      </div>
      <div class="text-xs-right">
        <v-btn :loading="exportloading" color="grey" outline @click="exportxlsxreward">
          <em class="fas fa-file-export" />
          &nbsp; Export ข้อมูลการสะสม&nbsp;
        </v-btn>
      </div>
      <div>
        <date-filter
          v-if="['100701258941039'].includes(selectedBot.pageid)"
          v-model="selectedDate"
          default-filter="last_7_days"
          @changeDate="onsearch"
        ></date-filter>
      </div>
      <v-pagination
        v-model="pageNumber"
        :total-visible="15"
        :length="pagelength"
        @input="changePage"
      ></v-pagination>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template #items="props">
          <tr>
            <td>{{ props.item.firstname }} {{ props.item.lastname }}</td>
            <td>
              {{ props.item.identitynumber }}
            </td>
            <td>
              <div style="width: 140px">
                <span>{{ props.item.phonenumber }}</span>
                <v-btn icon @click="onEditPhone(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </div>
            </td>
            <td>
              {{ props.item.email }}
            </td>
            <td>
              {{ props.item.id }}
            </td>
            <td>
              {{ props.item.shopname }}
            </td>
            <td>
              {{ props.item.shopprovince }}
            </td>
            <td>
              {{ props.item.points }}
            </td>
            <td>
              <v-btn color="primary" flat @click="openPointDetail(props.item)">ข้อมูลการสะสม</v-btn>
            </td>

            <td class="text-xs-right">
              <v-btn icon @click="editBranch(props.item)"> <v-icon>edit</v-icon></v-btn>
              <v-btn icon @click="ondeleteData(props.item)"> <v-icon>delete</v-icon></v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div>
        <v-dialog v-model="showEdit" persistent width="550px">
          <v-card v-if="showEdit">
            <MemberEdit
              :edittype="edittype"
              :editdata="editdata"
              @onsave="onsave"
              @close="showEdit = false"
            ></MemberEdit>
          </v-card>
        </v-dialog>
      </div>
      <v-dialog v-model="qrdialog" width="350px" persisten>
        <v-card v-if="qrdialog" class="text-xs-center pb-4">
          <div class="text-xs-right">
            <v-btn icon small @click="qrdialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <div style="font-size: 28px; font-weight: 600">
            {{ qrdata.department_store }}
          </div>
          <div style="color: black">
            {{ qrdata.branch }}
          </div>
          <div>
            <v-img class="mx-auto" width="200px" :src="qrdata.qr_code"></v-img>
          </div>
          <div>
            <a download="filename.jpeg" :href="qrdata.qr_code">
              <v-btn color="primary" @click="gotolink(qrdata.qr_code)">Download</v-btn></a
            >
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showsearch" width="500px" persistent>
        <v-card>
          <div style="float: right">
            <v-btn icon @click="showsearch = false"><v-icon>close</v-icon></v-btn>
          </div>
          <div class="pa-2 pt-4 pb-3">
            <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
            <div>
              <v-layout class="pa-0 ma-0" wrap row>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('ชื่อ - สกุล') }}</label>
                  <input v-model="filter.name" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('เลขบัตรประชาชน') }}</label>
                  <input v-model="filter.identityNumber" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm6 class="form-control pa-1">
                  <label>{{ $t('เบอร์โทรศัพท์') }}</label>
                  <input v-model="filter.phoneNumber" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm6 class="form-control pa-1">
                  <label>{{ $t('อีเมล') }}</label>
                  <input v-model="filter.email" class="form-control" type="text" />
                </v-flex>
              </v-layout>
            </div>
            <div class="text-xs-center">
              <v-btn outline color="grey" @click="clearsearch">Clear</v-btn>
              <v-btn color="primary" @click="onsearch">Search</v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showpointdetail" width="790px" persistent>
        <v-card v-if="showpointdetail">
          <MemberPointDetail
            :datavalue="pointdetaildata"
            @onsavecreate="getData"
            @close="showpointdetail = false"
          ></MemberPointDetail>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editPhone" persistent width="300px">
        <v-card v-if="editPhone">
          <div class="pa-2">
            <div class="text-xs-right pb-2">
              <v-btn icon outline @click="editPhone = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <div class="text-xs-left form-control">
              <span>Phone: </span>
              <input
                v-model="editDataPhone.phone"
                name="phone"
                type="text"
                class="form-control"
                outline
              />
            </div>
            <div class="text-xs-center pt-2">
              <v-btn :loading="loadingSavePhone" color="primary" @click="onSavePhone">
                <span>ตกลง</span>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import { mapGetters } from 'vuex'
import MemberEdit from './MemberEdit.vue'
import MemberPointDetail from './MemberPointDetail.vue'
import moment from 'moment'
import XLSX from 'xlsx'
import DateFilter from './TheNextFaceDateFilter'

export default {
  components: {
    MemberEdit,
    DateFilter,
    importxlsx,
    exportxlsx,
    MemberPointDetail
  },
  data() {
    return {
      pointdetaildata: '',
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      qrlink: '',
      qrdialog: false,
      showpointdetail: false,
      importloading: false,
      qrdata: '',
      showEdit: false,
      editdata: '',
      edittype: '',
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm'),
        end: moment().format('YYYY-MM-DD HH:mm')
      },
      pagination: { rowsPerPage: -1, sortBy: '' },
      columnName: '',
      items: [],
      filter: {
        name: '',
        identityNumber: '',
        phoneNumber: '',
        email: ''
      },
      exportloading: false,
      showsearch: false,
      loading: false,
      headers: [
        { text: 'ชื่อ - นามสกุล', value: 'firstname' },
        { text: 'เลขบัตรประชาชน', value: 'identitynumber' },
        { text: 'เบอร์โทร', value: 'phonenumber' },
        { text: 'อีเมล', value: 'email' },
        { text: 'รหัสสมาชิก', value: 'memberid' },
        { text: 'ชื่อร้านค้า', value: 'shopname' },
        { text: 'จังหวัด', value: 'shopprovince' },
        { text: 'เครื่องสะสม', value: 'points' },
        { text: 'ข้อมูลการสะสม', value: '' },
        { text: '', value: '' }
      ],
      editPhone: false,
      editDataPhone: {
        memberId: null,
        phone: null
      },
      loadingSavePhone: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ondeleteData(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            this.loading = true
            var data = {
              memberId: item.id,
              pageid: this.selectedBot.pageid
            }
            api.deleteYasaleMember(data, (err, response) => {
              this.loading = false
              if (response.responsecode == 200) {
                this.getData()
                this.$swal.fire({
                  type: 'success',
                  text: 'สำเร็จ'
                })
              }
            })
          }
        })
    },
    clearsearch() {
      this.filter = {
        name: '',
        identityNumber: '',
        phoneNumber: '',
        email: ''
      }
      this.getData()
      this.showsearch = false
    },
    onsearch() {
      this.getData()
      this.showsearch = false
    },
    async exportxlsxreward() {
      let data = {
        pageid: this.selectedBot.pageid
      }
      if (this.selectedDate.start && this.selectedDate.end) {
        data.datefrom = this.selectedDate.start
        data.dateto = this.selectedDate.end
      }
      this.exportloading = true
      api.getYasaleReward(data, (err, response) => {
        this.exportloading = false
        var exporteddata = response.data.imei
        var exporteddata2 = response.data.campaign
        var json = exporteddata.map((el) => {
          return {
            imei: el.imei,
            description: el.description,
            points: el.points,
            memberid: el.memberid,
            timestamp: el.timestamp ? moment(el.timestamp).format('DD/MM/YYYY HH:mm') : ''
          }
        })
        var json2 = exporteddata2.map((el) => {
          return {
            campaignname: el.campaignname,
            points: el.points,
            memberid: el.memberid,
            timestamp: el.timestamp ? moment(el.timestamp).format('DD/MM/YYYY HH:mm') : ''
          }
        })

        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'ข้อมูล เครื่องสะสมจาก IMEI' + '.xlsx')

        const dataWS2 = XLSX.utils.json_to_sheet(json2)
        const wb2 = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb2, dataWS2)
        XLSX.writeFile(wb2, 'ข้อมูล เครื่องสะสมจากแคมเปญ' + '.xlsx')
      })
    },
    async exportxlsx() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      if (this.selectedDate.start && this.selectedDate.end) {
        data.datefrom = this.selectedDate.start
        data.dateto = this.selectedDate.end
      }
      this.exportloading = true
      api.getYasaleMember(data, (err, response) => {
        var exporteddata = response.data

        var json = exporteddata.map((el) => {
          let address = `${el.shopaddress} ${el.shopsubdistrict} ${el.shopdistrict} ${el.shopprovince} ${el.shoppostcode}`
          return {
            memberid: el.id,
            'ชื่อ-นามสกุล': el.firstname + ' ' + el.lastname,
            เลขบัตรประชาชน: el.identitynumber,
            เบอร์โทร: el.phonenumber,
            อีเมล: el.email,
            ที่อยู่: address,
            เครื่องสะสม: el.points,
            ชื่อร้านค้า: el.shopname,
            จังหวัด: el.shopprovince,
            วันที่สมัคร: el.created_timestamp
              ? moment(el.created_timestamp).format('DD/MM/YYYY HH:mm')
              : '',
            เลขที่บัญชี: el.bankaccountnumber,
            ธนาคาร: el.bank
          }
        })

        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'exportedmember' + '.xlsx')
        this.exportloading = false
      })
    },
    openPointDetail(item) {
      this.pointdetaildata = item
      this.showpointdetail = true
    },
    onImport(item) {
      this.importloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        files: item[0]
      }
      api.importYasalePoints(data, async (err, response) => {
        this.importloading = false
        if (response.responsecode == 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
        } else {
          this.$swal.fire(response.reason)
        }
        this.getData()
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    editBranch(item) {
      this.editdata = item
      this.edittype = 'edit'
      this.showEdit = true
    },
    onsave() {
      this.showEdit = false
      this.getData()
    },
    gotolink(link) {
      this.$nextTick(() => {
        window.location.href = link
      })
      // location.assign(this.qrlink)
    },
    showQrcode(item) {
      this.qrdialog = true
      this.qrdata = item
    },
    addBranch() {
      this.edittype = 'create'
      this.showEdit = true
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,
        limit: this.limit,
        offset: this.offset
      }
      if (this.selectedDate.start && this.selectedDate.end) {
        data.datefrom = this.selectedDate.start
        data.dateto = this.selectedDate.end
      }
      for (const key in this.filter) {
        if (this.filter[key]) {
          Object.assign(data, { [key]: this.filter[key] })
        }
      }
      this.loading = true
      api.getYasaleMember(data, (err, response) => {
        this.loading = false
        this.items = response.data
        this.total = response.total
      })
    },
    onEditPhone(item) {
      this.editPhone = true
      this.editDataPhone.memberId = item.id
      this.editDataPhone.phone = item.phonenumber
    },
    onSavePhone() {
      this.loadingSavePhone = true
      let data = {
        pageId: this.selectedBot.pageid,
        memberId: this.editDataPhone.memberId,
        phone: this.editDataPhone.phone
      }
      api.updateMemberPhoneYasale(data, (err, response) => {
        this.loadingSavePhone = false
        if (response.responsecode == 200 && response.status) {
          this.editPhone = false
          this.$swal.fire({ text: 'อัพเดทเบอร์โทรศัพท์เรียบร้อย' })
          this.getData()
        } else {
          if (response.reason) {
            this.$swal.fire({ text: response.reason })
          } else {
            this.$swal.fire({ text: 'อัพเดทเบอร์โทรศัพท์ไม่สำเร็จ' })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/yasale/member/main.vue